import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import { apiRequest } from "../../apiServices/allApi";
const $ = require("jquery");
$.Datatable = require("datatables.net");

const DepositManual = () => {
  const [user, setUser] = useState();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const id = localStorage.getItem("id");

  //use for pagination..
  let [limit, setLimit] = useState(20);

  const setpageLimit = (event) => {
    let key = event.target.value;
    setLimit(key);
  };
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);

  //user for searching..
  const [searchList, setSearchList] = useState(0);
  const [searchType, setSearchType] = useState("Phone");
  const [findByStatus, setFindByStatus] = useState(0);
  const [amount, setAmount] = useState(0);
  const [searchList1, setSearchList1] = useState(0);
  const [reason, setReason] = useState(0);
  const [utr, setUtr] = useState(0);

  //   searching handler
  const searchHandler = (event) => {
    let key = event.target.value;

    setSearchList(key);
  };
  //   search by status handler
  const searchByStatus = (event) => {
    setSearchType("0");
    let key = event.target.value;
    setFindByStatus(key);
  };

  //react paginate..
  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setPageNumber(currentPage);
    // scroll to the top
  };
  const searchHandler1 = (event) => {
    let key = event.target.value;
    setSearchList1(key);
  };

  const amountAdd = (event) => {
    let key = event.target.value;
    setAmount(key);
  };
  const reasonToAdd = (event) => {
    let key = event.target.value;
    setReason(key);
  };
  const utrToAdd = (event) => {
    let key = event.target.value;
    setUtr(key);
  };

  const fetchData = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `admin/txn/get_deposit/allmanual?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&_status=${findByStatus}`,
        "GET",
        null,
        headers,
      );
      setUser(res.data.admin);
      setNumberOfPages(res.data.totalPages);
    } catch (error) {
    } finally {
    }
  };

  const universalCheckDeposit = (
    payment_gateway,
    order_id,
    order_token,
    pay_date,
  ) => {
    //alert(payment_gateway);
    if (window.confirm("Are you sure you want to proceed with this payment?")) {
      if (payment_gateway == "upigateway") {
        checkupigatewaypay(order_id, order_token, pay_date);
      } else if (payment_gateway == "paymanual") {
        checkupigatewaypaymanual(order_id, order_token, pay_date, "SUCCESS");
      } else if (!payment_gateway) {
        withdrowFail(order_id);
      } else {
        alert("Nothing found");
      }
    }
  };

  const depositAdd = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    const datas = {
      Phone: searchList1,
      amount: amount,
      reason: reason,
      UTR: utr,
    };
    try {
      const res = await apiRequest(
        `dipositupdate/whatsapp`,
        "POST",
        datas,
        headers,
      );
      if (res.data.status == false) {
        Swal.fire({
          title: "Oops...",
          text: res.data.message,
          icon: "error",
        });
      } else {
        Swal.fire({
          title: "deposit success",
          text: res.data.message,
          icon: "success",
        });
        window.location.reload();
      }
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: e.message,
        icon: "error",
      });
      if (e.data.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
      }
    } finally {
    }
  };

  const checkupigatewaypay = async (order_id, order_token) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `depositupipay/response`,
        { order_id, order_token },
        "POST",
        headers,
      );
      const icon = res.data.status == "PAID" ? "success" : "danger";
      const title =
        res.data.status == "PAID"
          ? "Deposit submited successfully"
          : "Transaction Failed";
      fetchData();
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
      }
    } finally {
    }
  };

  const checkupigatewaypaymanual = async (
    order_id,
    order_token,
    pay_date,
    status,
  ) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `userdipositupdate/${order_id}`,
        "POST",
        { status, status },
        headers,
      );
      const icon = res.data.status == "PAID" ? "success" : "danger";
      const title =
        res.data.status == "PAID"
          ? "Deposit submited successfully"
          : "Transaction Failed";
      fetchData();
    } catch (e) {
      if (e.response?.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
      }
    } finally {
    }
  };

  const PaymanualReject = async (order_id) => {
    const { value: manualPaymentInput } = await Swal.fire({
      title: "Enter Reject Payment Details",
      input: "text",
      inputPlaceholder: "Enter Reject Msg here",
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return "Payment details cannot be empty!";
        }
      },
    });

    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(
        `userdipositupdate/${order_id}`,
        "POST",
        { status: "FAILED", msg: manualPaymentInput },
        headers,
      );

      const icon = res.data.status == "PAID" ? "success" : "danger";
      const title =
        res.data.status == "PAID"
          ? "Deposit submited successfully"
          : "Transaction Failed";
      fetchData();
    } catch (e) {
      if (e.response.status == 401) {
      }
    } finally {
    }
  };

  const withdrowFail = async (id) => {
    const confirm = window.confirm(
      "Are you sure, you want to update to failed this deposit?",
    );
    if (confirm) {
      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };
      try {
        const res = await apiRequest(
          `userdipositupdate/${id}`,
          { status: "FAILED" },
          "POST",
          headers,
        );
        fetchData();
        alert("deposit successfully reject");
      } catch (e) {
      } finally {
      }
    }
  };

  // edit payment

  const EditPayment = (amount, txnId) => {
    const access_token = localStorage.getItem("token");

    Swal.fire({
      title: "Submit your Payment details",
      input: "number",
      inputValue: amount,
      inputAttributes: {
        autocapitalize: "on",
      },
      showCancelButton: true,
      confirmButtonText: "Submit",
      showLoaderOnConfirm: true,
      preConfirm: (login) => {
        const requestData = {
          amount: login,
          txnId: txnId,
        };
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`, // Set the appropriate content type
        };

        try {
          const res = apiRequest(
            "admin/txn_edit_payment",
            "POST",
            requestData,
            headers,
          );
          fetchData();
          if (!res.status == "ok") {
            throw new Error(res.statusText);
          }
        } catch (error) {
          Swal.showValidationMessage(`Request failed: ${error}`);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
    // finally {
    //   // setLoading(false)
  };

  // check in

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleString("default", {
      month: "long",
      day: "numeric",
      hour: "numeric",
      hour12: true,
      minute: "numeric",
    });
    return newDate;
  };

  const newdateFormat = (e) => {
    let today = new Date(e);
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    let yyyy = today.getFullYear();
    today = dd + "-" + mm + "-" + yyyy;
    return today;
  };

  useEffect(() => {
    fetchData();
  }, [pageNumber, limit, searchList, searchType, findByStatus]);

  if (user == undefined) {
    return null;
  }

  return (
    <>
      <div className="row mt-4">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body p-2">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="dashboard_heading m-0 text-success">
                  <i className="mdi mdi-cash-plus text-success mr-2"></i> Manual
                  Deposit Management
                </h4>
                <span className="badge badge-success px-3 py-2">
                  Manual Deposit
                </span>
              </div>

              {/* Add Payment Form */}
              <div className="admin-filter-bar">
                <input
                  type="number"
                  placeholder="User Phone..."
                  className="form-control"
                  onChange={searchHandler1}
                  required
                />

                <input
                  type="number"
                  placeholder="Amount (₹)..."
                  className="form-control"
                  onChange={amountAdd}
                  required
                />

                <input
                  type="text"
                  placeholder="Reason..."
                  className="form-control"
                  onChange={reasonToAdd}
                  required
                />

                <input
                  type="number"
                  placeholder="UTR Number..."
                  className="form-control"
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length >= 6) {
                      utrToAdd(e);
                    }
                  }}
                  required
                />

                <button
                  className="btn btn-success btn-sm "
                  onClick={depositAdd}
                >
                  <i className="mdi mdi-plus mr-1"></i> Add Payment
                </button>
              </div>

              {/* searching */}
              <div className="admin-filter-bar">
                <select
                  className="form-control"
                  style={{ maxWidth: "180px" }}
                  id="searchType"
                  name="searchtype"
                  onChange={(e) => setSearchType(e.target.value)}
                >
                  <option value="Phone">Search by Phone</option>
                  <option value="Name">Search by Name</option>
                  <option value="_id">Search by Txn ID</option>
                  <option value="RefId">Search by Ref ID</option>
                </select>

                <input
                  type="text"
                  placeholder="Search keywords..."
                  className="form-control"
                  style={{ flex: "1", minWidth: "180px" }}
                  onChange={searchHandler}
                />

                <select
                  className="form-control"
                  style={{ maxWidth: "170px" }}
                  id="findByStatus"
                  name="findByStatus"
                  onChange={searchByStatus}
                >
                  <option value="0">Filter Status</option>
                  <option value="PAID">PAID</option>
                  <option value="Pending">Pending</option>
                  <option value="FAILED">FAILED</option>
                  <option value="checkin">Checkin</option>
                </select>

                <select
                  className="form-control"
                  id="pagelimit"
                  name="pagelimit"
                  value={limit}
                  onChange={setpageLimit}
                >
                  <option value="10">10 / page</option>
                  <option value="20">20 / page</option>
                  <option value="50">50 / page</option>
                  <option value="100">100 / page</option>
                  <option value="500">500 / page</option>
                </select>
              </div>

              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th> Phone</th>
                      <th> User</th>
                      <th> UTR</th>
                      <th> ScreenShot</th>
                      <th> Amount </th>
                      {/* <th> ----- </th> */}
                      <th> Action By</th>
                      <th> Action </th>
                      <th> Status </th>
                      <th> Reason</th>
                      <th> Date </th>
                    </tr>
                  </thead>

                  <tbody>
                    {user &&
                      user.map((data, key) => {
                        return (
                          <tr>
                            <td>{key + 1}</td>

                            <td>
                              {localStorage.getItem("user") === "Admin" ||
                              localStorage.getItem("updateLegalData") ===
                                "true" ? (
                                <span className="pl-2">
                                  {data.User_id ? data.User_id.Phone : ""}
                                </span>
                              ) : (
                                <span className="pl-2">{`${
                                  "********" +
                                  data.User_id.Phone.toString().slice(-2)
                                }`}</span>
                              )}
                            </td>
                            <td>
                              {data.User_id && (
                                <Link
                                  className="btn btn-sm btn-outline-info"
                                  to={`/user/view_user/${data.User_id._id}`}
                                >
                                  {data.User_id.Name}
                                </Link>
                              )}
                            </td>

                            <td>
                              <span style={{ color: "blue" }}>
                                {data.order_token}
                              </span>
                            </td>

                            <td>
                              <a
                                href={`${baseUrl}/${data?.paymentImage}`}
                                target="_blank"
                              >
                                <img
                                  alt=""
                                  src={baseUrl + `/${data?.paymentImage}`}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                      "https://t4.ftcdn.net/jpg/04/73/25/49/360_F_473254957_bxG9yf4ly7OBO5I0O5KABlN930GwaMQz.jpg";
                                  }}
                                  className=""
                                  height={600}
                                />
                              </a>
                            </td>
                            <td>{data.amount}</td>

                            <td>
                              {data?.action_by && (
                                <Link
                                  className="btn btn-sm btn-outline-info"
                                  to={`/Agent/Data/${data?.action_by._id}`}
                                >
                                  {data?.action_by.Name}
                                </Link>
                              )}
                            </td>

                            <td>
                              {data.status != "PAID" &&
                              data.status != "FAILED" ? (
                                <>
                                  <button
                                    className="btn btn-danger mr-1"
                                    onClick={() =>
                                      universalCheckDeposit(
                                        data.payment_gateway,
                                        data.order_id,
                                        data._id,
                                        data.order_token,
                                        newdateFormat(data.createdAt),
                                      )
                                    }
                                  >
                                    Approve
                                  </button>

                                  <button
                                    className="btn btn-danger mr-1"
                                    onClick={() =>
                                      PaymanualReject(data.order_id)
                                    }
                                  >
                                    reject
                                  </button>

                                  <button
                                    className="btn btn-danger mr-2"
                                    onClick={() =>
                                      EditPayment(data.amount, data._id)
                                    }
                                  >
                                    Edit
                                  </button>
                                </>
                              ) : (
                                "Checked All"
                              )}
                            </td>

                            <td className="font-weight-bold text-success">
                              {data.status}
                            </td>
                            <td>
                              <span style={{ color: "blue" }}>
                                {" "}
                                {data.txn_msg.length > 15
                                  ? data.txn_msg.substring(0, 20) + "..."
                                  : data.txn_msg}
                              </span>
                            </td>
                            <td>{dateFormat(data.createdAt).split(",")[0]} </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>

              <div className="mt-4">
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={numberOfPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DepositManual;
